import { CSS_TOKEN } from "./index";

export class FontFamilyProperty {
    constructor(fontFamilies = "") {
        this.fontFamilyRegexp = new RegExp(CSS_TOKEN.FONT_FAMILY_NAME, 'g');
        this.value = [];
        this.update(fontFamilies);
    }

    update(newValue) {
        this.fontFamiliesRaw = newValue;
        if (FontFamilyProperty.isValid(newValue)) {
            let matches;
            this.value = [];
            while ((matches = this.fontFamilyRegexp.exec(newValue)) !== null) {
                if (matches[0]) {
                    this.value.push(matches[0])
                }
            }
            this.value = this.value.map(FontFamilyProperty.normalize);
            this.fontFamilyRegexp.lastIndex = 0;
            this.error = false;
        } else {
            this.error = true;
        }
    }

    build() {
        return this.value.map(FontFamilyProperty.denormalize).join(', ');
    }

    static isValid(input) {
        if (!input) {
            return true;
        }
        
        const trimmedInput = input.trim();
        const fontFamilies = trimmedInput.split(',');

        for (const fontFamily of fontFamilies) {
            const spacesCheckResult = checkSpaces(fontFamily);
            if (!spacesCheckResult) {
                return false;
            }

            let formattedFontFamily = fontFamily.replace(/\s/g, '');

            const singleQuoteCheckResult = checkSingleQuotes(formattedFontFamily);
            if (!singleQuoteCheckResult) {
                return false;
            }

            formattedFontFamily = formattedFontFamily.replace(/\\\\'/g, '').replace(/'/g, '');

            const doubleQuoteCheckResult = checkDoubleQuotes(formattedFontFamily);
            if (!doubleQuoteCheckResult) {
                return false;
            }

            formattedFontFamily = formattedFontFamily.replace(/\\\\"/g, '').replace(/"/g, '');

            const identifierCheckResult = checkIdentifier(formattedFontFamily);
            if (!identifierCheckResult) {
                return false;
            }
        }

        return true;
    }

    static normalize(input) {
        if (input !== undefined) {
            return input
                .replace(/^"((?:\\"|[^"])+)"$/, "$1")
                .replace(/^'((?:\\'|[^'])+)'$/, "$1")
                .replace(/\\"/g, '"')
                .replace(/\\'/g, "'");
        }
        return "";
    }

    static denormalize(input) {
        if (input !== undefined) {
            if (input.match(new RegExp(`^${CSS_TOKEN.IDENTIFIER}$`))) {
                return input;
            }

            return `'${input.replace(/(')/g, "\\$1")}'`;
        }
        return "";
    }
}

function checkSpaces(value) {
    const startSpaceRegExp = new RegExp(CSS_TOKEN.START_SPACE);
    const endSpaceRegExp = new RegExp(CSS_TOKEN.END_SPACE);

    if (!startSpaceRegExp.test(value) || !endSpaceRegExp.test(value)) {
        return false;
    }

    const trimmedValue = value.trim();
    const quotesRegExp = new RegExp(CSS_TOKEN.QUOTES);

    if (quotesRegExp.test(trimmedValue)) {
        return true;
    }

    const innerSpacesRegExp = new RegExp(CSS_TOKEN.SPACE);

    return !innerSpacesRegExp.test(trimmedValue);
}

function checkDoubleQuotes(value) {
    const doubleQuote = '"';
    return checkQuotes(doubleQuote, value);
}

function checkSingleQuotes(value) {
    const singleQuote = "'";
    return checkQuotes(singleQuote, value);
}

function checkQuotes(quote, value) {
    const startsWithQuoteAndDoesntEndWithQuote = value.startsWith(quote) && !value.endsWith(quote)
    const endsWithQuoteAndDoesntStartWithQuote = value.endsWith(quote) && !value.startsWith(quote)

    if (startsWithQuoteAndDoesntEndWithQuote || endsWithQuoteAndDoesntStartWithQuote) {
        return false;
    }

    let formattedValue = value;

    const startsWithQuoteAndEndsWithQuote = value.startsWith(quote) && value.endsWith(quote);

    if (startsWithQuoteAndEndsWithQuote) {
        formattedValue = formattedValue.slice(1, -1);
    }

    const quotesRegExp = getEscapedQuotesRegExp(quote);

    return quotesRegExp.test(formattedValue);
}

function getEscapedQuotesRegExp(quote) {
    if (quote === '"') {
        return new RegExp(CSS_TOKEN.ESCAPED_DOUBLE_QUOTES);
    }

    if (quote === "'") {
        return new RegExp(CSS_TOKEN.ESCAPED_SINGLE_QUOTES);
    }

    return new RegExp();
}

function checkIdentifier(value) {
    const identifierRegExp = new RegExp(CSS_TOKEN.IDENTIFIER);

    return identifierRegExp.test(value);
}



// WEBPACK FOOTER //
// ./lib/css-property-parser/FontFamilyProperty.js